/**
 * Banner in-app: aprovações pendentes do usuário logado.
 * Resolve a lacuna de "depender do e-mail" — o aprovador acha e abre a aprovação
 * direto no sistema. Some sozinho quando não há nada pendente. A ação de aprovar
 * acontece na tela /inovacao/aprovacao/:token (autenticada, já existente).
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, ArrowRight } from 'lucide-react';
import { aprovacoesAPI } from '../../services/inovacaoAPI';

const BRAND = 'var(--brand, #20a490)';

export default function MinhasAprovacoesPendentes() {
  const [itens, setItens] = useState([]);

  useEffect(() => {
    aprovacoesAPI.minhasPendentes().then(setItens).catch(() => {});
  }, []);

  if (!itens.length) return null;
  const plural = itens.length > 1;

  return (
    <div style={{ background: '#fff8ef', border: '1px solid #f0c089', borderRadius: 12,
                  padding: '16px 20px', marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12,
                    color: '#b9772a', fontWeight: 700 }}>
        <ClipboardCheck size={18} />
        Você tem {itens.length} aprovação{plural ? 'ões' : ''} pendente{plural ? 's' : ''}
      </div>
      <div style={{ display: 'grid', gap: 8 }}>
        {itens.map((a) => (
          <div key={a.aprovacao_id} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
            background: '#fff', border: '1px solid #f1e2cf', borderRadius: 8, padding: '10px 14px',
          }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, color: '#2c3e50', overflow: 'hidden',
                            textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {a.analise_titulo}
              </div>
              <div style={{ fontSize: '0.8rem', color: '#7f8c8d' }}>
                Seu papel: {a.papel_descricao}{a.obrigatorio ? ' · obrigatório' : ''}
              </div>
            </div>
            <Link to={`/inovacao/aprovacao/${a.public_token}`} style={{
              flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 6, background: BRAND,
              color: '#fff', padding: '8px 14px', borderRadius: 6, textDecoration: 'none',
              fontSize: '0.85rem', fontWeight: 600,
            }}>
              Analisar e aprovar <ArrowRight size={15} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
